import React, { useEffect } from "react";

import Main from '../components/CompositeReinforcement/Main'
import Projects from "../components/Home/Projects";
import Liam from "../components/Home/Liam";
import WhyWait from "../components/Home/WhyWait";
import KeyMaterial from "../components/CompositeReinforcement/KeyMaterial";
import Physical from "../components/CompositeReinforcement/Physical";
import WhyChoose from "../components/CompositeReinforcement/WhyChoose";
import CompositeReinKey from "../components/CompositeReinforcement/CompositeReinKey";
import PhysicalMechanical from "../components/MansoryMesh/PhysicalMechanical";
import ContactUs from "../components/MansoryMesh/ContactUs";
import Areas from "../components/CompositeReinforcement/Areas";

function CompositeReinforcement () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>     
            <KeyMaterial/>
            <Physical/>
            <WhyChoose/>
            <PhysicalMechanical/> 
            <ContactUs/>
            <Projects/>
            <CompositeReinKey/>
            <Areas/>
            {/* <Liam/>
            <WhyWait/> */}
        </div>
    );
}

export default CompositeReinforcement;